export const ssoEnabled = () => {
  const samlRedirectUrl = localStorage.getItem("samlRedirectUrl") || "";
  return samlRedirectUrl.length > 0;
};
